<template>
    <div class="field has-addons">
        <p class="control">
            <input class="input is-small time-input" type="text" :value="estimatedTime" readonly />
        </p>
        <p class="control">
            <a class="button is-static is-small label-button">
                <time class="deviation"
                    ><strong>{{ humanDeviation }}</strong></time
                >
                <PunctualityIcon
                    :timeliness="timeliness"
                    :deviationSeconds="deviationSeconds"
                    class="punctuality-icon"
                />
            </a>
        </p>
    </div>
</template>

<script>
import moment from 'moment'
import { deviation } from '@/utils/time/deviation'
import PunctualityIcon from '@/widgets/PunctualityIcon'

export default {
    name: 'Punctuality',
    components: {
        PunctualityIcon,
    },
    props: {
        timeliness: String,
        deviationSeconds: Number,
        estimated: String,
    },
    computed: {
        estimatedTime() {
            const { estimated } = this.$props
            return moment(estimated).format('HH:mm')
        },
        deviationMinutes() {
            const { deviationSeconds } = this.$props
            return Math.abs(Math.floor(deviationSeconds / 60))
        },
        humanDeviation() {
            const { deviationSeconds } = this.$props
            return deviation(deviationSeconds)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../sass/variables';

.time-input {
    width: 50px;
}

.label-button {
    width: 80px;
}

.deviation {
    margin-right: 7px;
}
</style>
